import { portalsApplicationsTheme } from './portalsApplications.theme'
import { portalsAuthTheme } from './portalsAuth.theme'
import { portalsNavbarTheme } from './portalsNavbar.theme'

export const portalDefaultTheme = {
   dark: {},

   light: {
      portalsApplications: portalsApplicationsTheme.light,
      portalsAuth: portalsAuthTheme.light,
      portalsNavbar: portalsNavbarTheme.light
   }
}
